module.exports = __webpack_public_path__ + "static/img/100x100_ICONS_1.4311b2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/100x100_ICONS_1.png
// module id = 1l88
// module chunks = 0